import React, { useState, useEffect } from "react";
import { StyledDialog, StyledButton, StyledBox, StyledTypo, StyledPaper } from "../StyledMui";
import { Popper, Select, MenuItem, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Typography, IconButton, DialogTitle, DialogContent, DialogActions, InputAdornment, TextField } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useStore from "../Store";

function Mapper(props) {
  const [selectedField, setSelectedField] = useState("");
  const [mappedField, setMappedField] = useState("");
  const [open, setOpen] = useState(false);
  const [isCustomInput, setIsCustomInput] = useState([]);
  const { defields, setMapping, isInit, toggleIsInit, contacts, getContacts, sendTarget, setSendTarget, selectedTemplate, setSelectedTemplate } = useStore((state) => state.mapper);
  const { initData, datas, setDatas, setInitData } = useStore((state) => state.mapper);
  const [labels, setLabels] = useState([]);

  // Initialize selectedTemplate on load
  useEffect(() => {
    if (selectedTemplate?.msg_no) {
      setInitData(selectedTemplate.msg_no);
    }
  }, [selectedTemplate, setInitData]);

  // Parse variables and update datas
  useEffect(() => {
    if (initData) {
      const parsedLabels = parseTemplateVariables(initData);
      setLabels(parsedLabels);
      setDatas(parsedLabels.map(label => ({ name: label.value, value: "", type: "", context: label.context })));
    }
  }, [initData, setDatas]);

  // Parse template variables for fields
  const parseTemplateVariables = (template) => {
    let labelMatches = [];
    const templateContent = template.templateContent || "";

    // Match template variables
    const matches = templateContent.match(/#\{[^}]+\}/g) || [];
    labelMatches = matches.map(label => ({ value: label.slice(2, -1), context: "template" }));

    // Match button variables
    if (template.buttons) {
      JSON.parse(template.buttons)?.forEach(buttonGroup => {
        buttonGroup.forEach(button => {
          const buttonMatches = button.name.match(/#\{[^}]+\}/g) || [];
          buttonMatches.forEach(label => {
            labelMatches.push({ value: label.slice(2, -1), context: "button" });
          });
        });
      });
    }

    // Remove duplicates
    return labelMatches.filter((label, index, self) =>
      index === self.findIndex(l => l.value === label.value && l.context === label.context)
    );
  };

  useEffect(() => {
    setIsCustomInput(datas.map((data) => data.type === "text" || data.type === "date"));
  }, [datas]);

  // Handle field change
  const handleChange = (event, index) => {
    const tmpDatas = [...datas];
    const value = event.target.value;
    if (value === "custom" || value === "TODAY()") {
      const type = value === "custom" ? 'text' : 'date';
      tmpDatas[index] = { ...datas[index], type };
    } else {
      tmpDatas[index] = { ...datas[index], value, type: "field" };
    }
    setDatas(tmpDatas);
  };

  // Handle custom input change
  const handleCustomInput = (event, index) => {
    const tmpDatas = [...datas];
    tmpDatas[index] = { ...datas[index], value: event.target.value };
    setDatas(tmpDatas);
  };

  // Handle field restart
  const handleRestart = (index) => {
    const tmpDatas = [...datas];
    tmpDatas[index] = { ...datas[index], type: "field" };
    setDatas(tmpDatas);
  };

  // Handle dialog open
  const handleClick = async () => {
    if (contacts.length === 0) await getContacts();
    setOpen(true);
  };

  // Handle dialog close
  const handleClose = () => {
    setOpen(false);
  };

  // Handle field select
  const handleFieldSelect = (event) => {
    setSelectedField(event.target.value);
  };

  // Handle mapping select
  const handleMappingSelect = (event) => {
    setMappedField(event.target.value);
  };

  return (
    <>
      <StyledPaper style={{ height: "100%" }}>
        {/* <StyledBox component="div">
          <StyledTypo>원키코드 지정</StyledTypo>
        </StyledBox> */}

        {/* <Grid container alignItems="center" spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item xs={false} sm={5}>
            <Box display="flex" justifyContent="center" width="100%">
              <Select size="small" value={sendTarget?.["type"]} onChange={(event) => setSendTarget({ ...sendTarget, type: event.target.value })} displayEmpty fullWidth>
                <MenuItem value="">데이터 컬럼 선택</MenuItem>
                <MenuItem value="recipient">Onekey</MenuItem>
              </Select>
            </Box>
          </Grid>
          <Grid item xs={2} sm={2}>
            <Box display="flex" justifyContent="center">
              <IconButton onClick={handleClick}>
                여기1
                <ArrowRightAltIcon fontSize="large" style={{ transform: "scaleX(2.5)" }} />
                여기2
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={false} sm={5}>
            <Box width="100%">
              <Select
                PopperComponent={Popper}
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                  PaperProps: {
                    style: {
                      maxHeight: 40 * 4.5,
                    },
                  },
                }}
                size="small"
                value={sendTarget?.["value"]}
                onChange={(event) => setSendTarget({ ...sendTarget, value: event.target.value })}
                displayEmpty
                fullWidth>
                <MenuItem value="">데이터 컬럼 선택</MenuItem>
                {defields.map((defield, idx) => (
                  <MenuItem key={idx} value={defield}>
                    {defield}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
        </Grid> */}

        <StyledDialog open={open} onClose={handleClose}>
          <DialogTitle>미리보기 데이터 선택</DialogTitle>
          <DialogContent>
            <Grid container alignItems="flex-start" spacing={2}>
              <Grid item sm={5}>
                <StyledPaper>
                  <StyledBox component="div">
                    <StyledTypo>템플릿 변수 지정</StyledTypo>
                  </StyledBox>
                  <Grid container alignItems="center" spacing={2}>
                    {labels.length === 0 ? (
                      <Grid item xs={12}>
                        <Typography variant="body1">선택한 템플릿 내용에 변수처리된 부분이 존재하지 않습니다.</Typography>
                      </Grid>
                    ) : (
                      labels.map((label, index) => label.context === "template" && (
                        <Grid key={label.value} item xs={false} sm={5}>
                          <Box display="flex" justifyContent="center" width="100%">
                            <Typography variant="body1">{label.value}</Typography>
                          </Box>
                        </Grid>
                      ))
                    )}
                  </Grid>
                </StyledPaper>
              </Grid>
              <Grid item sm={7}>
                <StyledPaper>
                  <StyledBox component="div">
                    <StyledTypo>Entry Source 데이터 미리보기</StyledTypo>
                  </StyledBox>
                  <Box sx={{ overflowX: "auto" }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>{contacts.length > 0 ? Object.keys(contacts[0]).map((key) => <TableCell>{key}</TableCell>) : ""}</TableRow>
                      </TableHead>
                      <TableBody>
                        {contacts?.map((contact) => (
                          <TableRow key={contact.id}>
                            {Object.values(contact).map((value, index) => (
                              <TableCell key={index}>{value}</TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </StyledPaper>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <IconButton
              autoFocus
              onClick={handleClose}
              color="primary"
              style={{
                position: "absolute",
                left: "97%",
                top: "-40px",
                transform: "scale(1.5)",
                color: "lightgrey",
              }}>
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </StyledDialog>
      </StyledPaper>
    </>
  );
}

export default Mapper;
